const mockApplications = [
    {
        id: 1,
        event_id: 1,
        student_number: "2003923",
        company_name: "Oyak",
        name: "Selen",
        surname: "Aytaş",
        department_name: "Bilgisayar Mühendisliği",
        participation: "1/24",
        event_name: "Değişen Dünyada Gelişen",
        status: "approved"
    },
    {
        id: 2,
        event_id: 1,
        student_number: "2004512",
        company_name: "Vestel",
        name: "Ali",
        surname: "Kaya",
        department_name: "Elektrik Mühendisliği",
        participation: "2/24",
        event_name: "Değişen Dünyada Gelişen",
        status: "pending"
    },
    {
        id: 3,
        event_id: 1,
        student_number: "2005678",
        company_name: "Arçelik",
        name: "Zeynep",
        surname: "Demir",
        department_name: "Endüstri Mühendisliği",
        participation: "3/24",
        event_name: "Değişen Dünyada Gelişen",
        status: "rejected"
    }
];

const getAll = async (eventId, config) => {
    const filter = config?.params?.filter ?? {};
    let rows = mockApplications.filter((r) => r.event_id === Number(eventId));

    if (filter.student_number) {
        rows = rows.filter((r) => r.student_number.includes(filter.student_number));
    }
    if (filter.status) {
        rows = rows.filter((r) => r.status === filter.status);
    }
    if (filter.company_id) {
        rows = rows.filter((r) => r.company_id === filter.company_id);
    }

    return Promise.resolve({
        data: {
            data: rows,
            pagination: { total: rows.length }
        }
    });
};

const updateStatus = async (id, status) => {
    const row = mockApplications.find((r) => r.id === Number(id));
    if (row) row.status = status;
    return Promise.resolve({ data: { message: 'success' } });
};

const approveAll = async (eventId) => {
    mockApplications
        .filter((r) => r.event_id === Number(eventId))
        .forEach((r) => { r.status = 'approved'; });
    return Promise.resolve({ data: { message: 'success' } });
};

const remove = async (id) => {
    const index = mockApplications.findIndex((r) => r.id === Number(id));
    if (index !== -1) mockApplications.splice(index, 1);
    return Promise.resolve({ data: { message: 'success' } });
};

export default {
    getAll,
    updateStatus,
    approveAll,
    remove
};
